export default {
  environment: 'online',     //debug or online
  api: {
    // url: 'http://10.10.107.200:8100',
    url: 'https://api.megaovip.com',
     //url: 'http://api.test.megaovip.com',
    // url: 'http://api.meigou.local',
    // websocket: 'ws://10.1.2.8:18282 '
    websocket: 'ws://api.megaovip.com:9589'
  }
}


// WEBPACK FOOTER //
// ./.config.js